import { Component, OnInit, Input, Optional, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { IonCheckbox } from '@ionic/angular';

@Component({
  selector: 'c-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: false
})
export class CheckboxComponent<T = any> implements OnInit, ControlValueAccessor {
  @Input() label = '';
  @Input() subtitle: string;
  @Input() showError = true;

  @ViewChild('checkbox') checkbox: IonCheckbox | undefined;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get control() {
    return this.ngControl?.control as FormControl;
  }

  ngOnInit(): void {}

  writeValue(value: any): void {}

  onCheckedChange = () => {
    this.control.setValue(this.checkbox.checked);
  };

  onChange = (value: T) => {};
  onTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
}
